import { useState } from 'react'
import './home.css'

import { Link } from 'react-router-dom'

import { auth } from '../../firebaseConnection'
import { signInWithEmailAndPassword, getAuth, sendPasswordResetEmail } from 'firebase/auth'

import { ToastContainer, toast } from 'react-toastify'


import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom'

export default function Home() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('')
  const [error, setError] = useState('');

  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setError('');

    // if (!email) {
    //   setError('Por favor, insira um email válido.');
    //   return;
    // }

    // if (!password) {
    //   setError('Por favor, insira uma senha.');
    //   return;
    // }

    try {
      await signInWithEmailAndPassword(auth, email, password)
        // Redirecionar ou exibir mensagem de sucesso
        .then(() => {
          navigate('/admin', { replace: true })
        })
    } catch (error) {
      console.error("Erro ao fazer login:", error); // Adicione esta linha para depuração

      switch (error.code) {
        case 'auth/user-not-found':
          setError("Usuário não encontrado.");
          break;
        case 'auth/wrong-password':
          setError('Senha incorreta.');
          break;
        case 'auth/invalid-email':
          setError('Email inválido.');
          break;
        default:
          setError('Erro ao fazer login. Tente novamente.');
          break;
      }
    }
    // } catch (err) {
    //   switch (err.code) {
    //     case 'auth/user-not-found':
    //       setError('Usuário não encontrado.');
    //       break;
    //     case 'auth/wrong-password':
    //       setError('Senha incorreta.');
    //       break;
    //     default:
    //       setError('Erro ao fazer login. Tente novamente.');
    //       break;
    //   }
    // }
  };

  //   if (email !== '' && password !== '') {

  //     await signInWithEmailAndPassword(auth, email, password)
  //       .then(() => {
  //         navigate('/admin', { replace: true })
  //       })

  //       .catch(() => {
  //         console.log("Erro ao fazer o login")
  //       })

  //   } else {

  //     toast.error("Preencha todos os campos!");

  //     //alert("Preencha todos os campos!")
  //   }
  // }

  function forgotPassword() {
    const auth = getAuth();
    sendPasswordResetEmail(auth, email)
      .then(() => {
        toast.info(" Um email para redefinição de senha enviado!")
        //alert("Email para redefinição de senha enviado!");
        setPassword('');
      })
      .catch((error) => {

        toast.error("Preencha o email!");

        //alert("Preencha o email!")
        // ..
      });
  }


  return (
    <div className="home-container">
      <ToastContainer />
      <h1>Agenda Online</h1>
      <span>Planeje seu tempo facilmente</span>

      <form className="form" onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Digite seu email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}

        />

        <input
          type='password'
          placeholder='Digite sua senha'
          value={password}
          onChange={(e) => setPassword(e.target.value)}

        />

        <button type='submit'>Acessar</button>
        {error && <p className="error-message">{error}</p>}

      </form>

      <Link className='button-link' to='/register'>
        Não possui uma conta? Cadastre-se
      </Link >
      <Link className='forgot-password'>
        <button onClick={forgotPassword}>Esqueci a senha</button>
      </Link>

    </div>
  )
}